module.exports = __webpack_public_path__ + "static/media/Chat.556fb9f3.png";